import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import parse from 'autosuggest-highlight/parse';
import throttle from 'lodash/throttle';
import Geocode from "react-geocode";
import { isMobileOnly } from 'react-device-detect';
import { useSelector } from 'react-redux';

Geocode.setApiKey("AIzaSyCPE0_u2njCH5xFF-WectE7Tex3iLBu1rY");
Geocode.setLanguage("en");
Geocode.setRegion("au");
Geocode.enableDebug();


const autocompleteService = { current: null };

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.text.secondary,
    marginRight: theme.spacing(2),
  },
}));



export default function GoogleMaps({isEmpty, inputValue, setInputValue, removeContent}) {
  const classes = useStyles();
  //const [inputValue, setInputValue] = React.useState(localStorage.getItem("current-address") || '');
  const [options, setOptions] = React.useState([]);
  
  //console.log(shop)
  const isUpdated = useSelector(state => state.serviceWorkerUpdated,);

  const selectOption = () => (event, value) => {
    setInputValue(value);
    Geocode.fromAddress(value).then(response => {
      //console.log(response)
      localStorage.setItem('current-lat',response.results[0].geometry.location.lat)
      localStorage.setItem('current-long',response.results[0].geometry.location.lng)
      //console.log(response.results[0])
      if (response.results[0].address_components[2]) localStorage.setItem('current-suburb', response.results[0].address_components[2].long_name) 
      else if(response.results[0].address_components[1]) localStorage.setItem('current-suburb', response.results[0].address_components[1].long_name)
      else if(response.results[0].address_components[0]) localStorage.setItem('current-suburb', response.results[0].address_components[0].long_name)
      if (isUpdated) localStorage.setItem('isUpdatedAvailable', "Yes")
    },
    error => {
      //console.error(error)
      localStorage.setItem('current-lat', -34.922851);
      localStorage.setItem('current-long', 138.60232);
      localStorage.setItem('current-suburb', 'Adelaide')
      localStorage.setItem('isUpdatedAvailable', "No")
      if (isUpdated) localStorage.setItem('isUpdatedAvailable', "Yes")
    }
    );
    localStorage.setItem("current-address",value);
    removeContent({dummy: []})
    if (isUpdated) localStorage.setItem('isUpdatedAvailable', "Yes")
  }

  const handleChange = (event) => {
    setInputValue(event.target.value);
    removeContent({dummy: []})
  };

  const navWidth = () => {
    if (isMobileOnly) return '60vw'
    else return '30vw'
  }

  const fetch = React.useMemo(
    () =>
      throttle((request, callback) => {
        autocompleteService.current.getPlacePredictions(request, callback);
      }, 200),
    [],
  );

  React.useEffect(() => {
    let active = true;

    if (!autocompleteService.current && window.google) {
      autocompleteService.current = new window.google.maps.places.AutocompleteService();
    }
    if (!autocompleteService.current) {
      return undefined;
    }

    if (inputValue === '') {
      setOptions([]);
      return undefined;
    }

    fetch({ input: inputValue }, (results) => {
      if (active) {
        setOptions(results || []);
      }
    });

    return () => {
      active = false;
    };
  }, [inputValue, fetch]);

  return (
    <Autocomplete
      freeSolo
      disabled = {!isEmpty}
      onInputChange = {selectOption()}
      value = {inputValue}
      //defaultValue = {inputValue}
      id="google-map-demo"
      style={{ width: navWidth() }}
      getOptionLabel={(option) => (typeof option === 'string' ? option : option.description)}
      filterOptions={(x) => x}
      options={options}
      includeInputInList
      renderInput={(params) => (
        <TextField
          {...params}
          label = "Address"
          variant="outlined"
          fullWidth
          onChange={handleChange}
        />
      )}
      renderOption={(option) => {
        const matches = option.structured_formatting.main_text_matched_substrings;
        const parts = parse(
          option.structured_formatting.main_text,
          matches.map((match) => [match.offset, match.offset + match.length]),
        );

        return (
          <Grid container alignItems="center">
            <Grid item>
              <LocationOnIcon className={classes.icon} />
            </Grid>
            <Grid item xs>
              {parts.map((part, index) => (
                <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                  {part.text}
                </span>
              ))}

              <Typography variant="body2" color="textSecondary">
                {option.structured_formatting.secondary_text}
              </Typography>
            </Grid>
          </Grid>
        );
      }}
    />
  );
}